import type { ReactElement } from "react"

/**
 * A gear, matched to `BookLink`'s stroke weight and 20px sizing so the two sit
 * as one family in the header rather than a mismatched pair.
 *
 * `currentColor` throughout, so it takes the audience's label colour.
 */
export const ManageAccess = ({ size = 20 }: { readonly size?: number }): ReactElement => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 13a7.4 7.4 0 0 0 0-2l2-1.5-2-3.5-2.4 1a7.4 7.4 0 0 0-1.7-1L15 3.5h-6l-.3 2.5a7.4 7.4 0 0 0-1.7 1l-2.4-1-2 3.5L4.6 11a7.4 7.4 0 0 0 0 2l-2 1.5 2 3.5 2.4-1a7.4 7.4 0 0 0 1.7 1l.3 2.5h6l.3-2.5a7.4 7.4 0 0 0 1.7-1l2.4 1 2-3.5z" />
  </svg>
)
